import { Capacitor } from "@capacitor/core";
async function registerCapacitorDeepLinks() {
  if (!Capacitor.isNativePlatform()) return;
  const { App } = await import("@capacitor/app");
  const closeInAppBrowser = async () => {
    // Dismiss the SFSafariViewController / Custom Tab opened for Google OAuth.
    try {
      const { Browser } = await import("@capacitor/browser");
      await Browser.close();
    } catch {
    }
  };
  const handleUrl = (url) => {
    if (!url || typeof url !== "string") return;
    const m = url.match(/[?&]token=([^&#]+)/);
    if (!m) return;
    let token;
    try {
      token = decodeURIComponent(m[1]);
    } catch {
      token = m[1];
    }
    if (!token) return;
    closeInAppBrowser();
    localStorage.setItem("auth_token", token);
    window.location.replace(`#/auth/callback?token=${encodeURIComponent(token)}`);
  };
  App.addListener("appUrlOpen", ({ url }) => handleUrl(url));
  try {
    const launch = await App.getLaunchUrl();
    if (launch?.url) handleUrl(launch.url);
  } catch {
  }
}
export {
  registerCapacitorDeepLinks
};
